<template>
    <div class="question-top">
        <div class="question-title">
            <img class="question-icon" :src="fieldImage(field.type)" :alt="field.type" />
            <question-title :color="colors.baseColor" :title="field.title" :required="field.required"></question-title>
        </div>
        <question-description :color="colors.secondaryColor" :description="field.description" v-if="field.description !== ''"></question-description>
    </div>
</template>

<script>
    export default {
        name: 'QuestionAttributes',
        props: ['field', 'colors'],
        methods: {
            fieldImage(type) {
                return 'https://static-resources-guestflip.s3.eu-central-1.amazonaws.com/'
                    + type + '.png'
            }
        }
    }
</script>
<style>
.field-title span {
    color: #90919e;
    font-size: 12px;
    font-weight: 600;
    vertical-align: middle;
    margin-right: 5px;
}
.field-title img {
    vertical-align: middle;
}
.question-title {
    margin-bottom: 0.5em;
}
.range-selection-wrapper.condensed .question-title {
    margin: 0;
}
.range-selection-wrapper.condensed .question-top .question-icon {
    display: none;
}
.question-title .question-icon {
    display: inline-block;
    margin-right: 11px;
    vertical-align: middle;
}
.question-title .title {
    display: inline-block;
    vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// node_modules/survey-fields/src/Question/QuestionAttributes.vue